module.exports = __webpack_public_path__ + "img/banner3_3.f155a38b.png";